import './UnsubscribeFromEmails.css';

import React, { useEffect } from 'react';
import { Typography } from '@vtblife/uikit';
import { Size, Spinner } from '@vtblife/uikit/legacy';

import { UnsubscribeRoute, useRouter } from '@search/offer-search-routes/src';
import classname from '@search/classname/src';
import { useStaticPathConfig } from '@search/common-core/src/StaticPathContext';

import Image from '../Image';
import M2illustration from './M2_illustration.url.svg';
import { useUnsubscribeSearchMutation } from './UnsubscribeSearchMutation';
import { useUnsubscribePriceChangeMutation } from './UnsubscribePriceChangeMutation';

const cn = classname.bind(null, 'UnsubscribeFromEmails');

export const UnsubscribeFromEmails = () => {
    const router = useRouter();
    const unsubscribeRoute = router.route(UnsubscribeRoute);
    const params = unsubscribeRoute.params();
    const unsubscribeFromSearch = useUnsubscribeSearchMutation();
    const unsubscribeFromPriceChange = useUnsubscribePriceChangeMutation();

    const staticPath = useStaticPathConfig();

    const [ response, setResponse ] = React.useState({
        isLoading: true,
        isUnsubscribed: false,
        error: undefined as undefined | string | Error
    });

    useEffect(() => {
        if (params.sid.length && ! params.oid) {
            unsubscribeFromSearch({ searchIds: params.sid, userId: params.uid })
                .then(res => {
                    setResponse({
                        isLoading: false,
                        isUnsubscribed: res.data?.unsubscribeFromSearchOpen.isUnsubscribed ?? false,
                        error: res.data?.unsubscribeFromSearchOpen.firstError?.__typename
                    });
                })
                .catch(error => {
                    setResponse({
                        isLoading: false,
                        isUnsubscribed: false,
                        error
                    });
                });
        }
    }, [ params.sid, params.uid, params.oid, unsubscribeFromSearch ]);

    useEffect(() => {
        if (params.oid && ! params.sid.length) {
            unsubscribeFromPriceChange({ offerId: params.oid, userId: params.uid })
                .then(res => {
                    setResponse({
                        isLoading: false,
                        isUnsubscribed: res.data?.unsubscribeFromPriceChangeOpen.isUnsubscribed ?? false,
                        error: res.data?.unsubscribeFromPriceChangeOpen.firstError?.__typename
                    });
                })
                .catch(error => {
                    setResponse({
                        isLoading: false,
                        isUnsubscribed: false,
                        error
                    });
                });
        }
    }, [ params.oid, params.uid, params.sid, unsubscribeFromPriceChange ]);

    return (
        <div className={cn()}>
            {! response.isLoading ? (
                <>
                    <Image
                        className={cn('image')}
                        url={`${staticPath}${M2illustration}`}
                    />
                    <div>
                        <h2 className={cn('title')}>
                            {response.error ? 'Что-то пошло не так' : 'Отписка от рассылки'}
                        </h2>
                        <Typography variant='primary'>
                            {response.error ?
                                <>
                                    Произошла ошибка<br />попробуйте ещё раз позже.
                                </> :
                                <>
                                    Вам на почту больше не будут приходить <br />
                                    уведомления о новых объявлениях по этой подписке.
                                </>
                            }
                        </Typography>
                    </div>
                </>
            ) : (
                <div className={cn('loader')}>
                    <Spinner size={Size.Medium} />
                </div>
            )}
        </div>
    );
};
